module.exports = __webpack_public_path__ + "img/topindicator10.08b0857a.png";